import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Text } from '@fiverr-private/typography';
import { BUYABLE_TYPE, useClientBuyableFeePolicy } from '@fiverr-private/price_upfront_components';
import { POLICY_TO_KEY } from '../../../GigCards/Components/Price/Price.constants';
import { AppI18n } from '../../../i18n';

export const PriceUpfrontTooltip = () => {
    const policy = useClientBuyableFeePolicy(BUYABLE_TYPE.GIG);
    const priceUpfrontKey = POLICY_TO_KEY[policy];

    if (!priceUpfrontKey) {
        return null;
    }

    return (
        <Stack direction="column">
            <Text fontWeight="bold" size="b_sm" color="white">
                <AppI18n k={`gig_cards.price.${priceUpfrontKey}.title`} />
            </Text>
            <Text size="b_sm" color="white">
                <AppI18n k={`gig_cards.price.${priceUpfrontKey}.description`} />
            </Text>
        </Stack>
    );
};
